import React from "react"
import { type ConnectedProps, connect } from "react-redux"

import type { RootState } from "../../../store.ts"
import { CreateLeadWizard } from "./wizard/CreateLeadWizard.tsx"

// No filter-options fetch: this route is a child of the leads list, which is
// mounted underneath and has already loaded them.
const LeadAddPage = ({
  saving,
  filterOptions
}: ConnectedProps<typeof connector>) => (
  <CreateLeadWizard options={filterOptions} saving={saving} />
)

const mapStateToProps = (state: RootState) => ({
  filterOptions: state.leads.filterOptions,
  saving: state.lead.saveFetching
})

const connector = connect(mapStateToProps)
export default connector(LeadAddPage)
